import React, { useEffect, useState } from "react";

function Logout({history}) {
  useEffect(() => {

    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("localSelected");
    localStorage.removeItem("categoriaSelected");
    window.location.href="/login"
  }, []);

  return <div />;
}

export default Logout;
